<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0050_id_approval_history</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-search title="ID申請履歴"></title-and-search>
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allSearchFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <div style="margin-top:5px;">
            <br>
            <button :disabled="false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;" @click="bulkApprovalStage4" >申請クリア</button>
            <button :disabled="disablePageApprove" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" @click="bulkApprovalStage1" >承認</button>
          </div>
        </div>
        <confirmation-modal tag="stage1ConfirmatioModal" @done="bulkApprovalStage2" />
        <confirmation-modal tag="stage2ConfirmatioModal" @done="bulkApprovalStage3" />
    </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_id_approval_history';
import { utils } from '@/libs/utils';


import _debug from 'debug';
var mdebug = _debug('esma:approval_history');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import constants from "@/rules/constants";


import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      api_name:"id_approval_history",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      execute_filter_on_back:true,
      page_acl: acl.generic,
      user_id:"",
      is_logged_user_admin:false,
      disable_page_approve:true
    };
  },
  computed: {
    disablePageApprove:{
      get(){
        return this.disable_page_approve;
      },
      set(v){
        this.disable_page_approve = v;
      }
    },
    isLoggedUserAdmin:{
      get(){
        return this.is_logged_user_admin;
      },
      set(v){
        this.is_logged_user_admin = v;
      }
    },
    userId:{
      get(){
        return this.user_id;
      },
      set(v){
        this.user_id = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    allSearchFields(){
      return this.tabFieldList;
    },
    tabFieldList() {
      return [
        utils.extend(fields.approval_status, {
          options: [
            "承認済", // Approved
            "申請中",   // Applying
            "差戻"      //Reject
          ]
        }),
        utils.extend(fields.syubetu, {}),
        utils.extend(fields.control_number, {}),
        utils.extend(fields.toroku_number, {}),
        utils.extend(fields.applicant_label, {}),
        utils.extend(fields.next_approver_label, {}),
        utils.extend(fields.update_name_label, {}),
        utils.extend(fields.create_time, {}),
        utils.extend(fields.update_time, {}),
      ];
    }
  },
  methods: {
    bulkApprovalStage1(){
      /**
       * 1 - Show onfirmation screen
       */
      this.$ajax.post("/id_approval_history/count_prepared", {}, (err, qty) => {
        console.log({qty})
        if(err){
        this.$notify({
            title: "データの承認に失敗しました。",
            text:err,
            type: "error",
            duration: 10000
          });
        }else{
          console.log("bulkApprovalStage1",{qty})
          this.gridOptions.api.purgeInfiniteCache();
          bus.$emit("stage1ConfirmatioModal",{
            title: "選択中　"+qty+"件",
            message: "承認を行います。よろしいですか？",
            yes_label: "承認",
            no_label: "戻る",
            yes_color:"info",
            no_color:"default",
            model_height:"50"
          })
        }
      });
    },
    bulkApprovalStage2(mode){
      /**
       * 2 - When aprove, execute at the server
       * 3 - Then show the results message.
       */
      if(mode != "yes"){
        return;
      }
      this.$ajax.post("/id_approval_history/approve", {}, (err, response) => {
        console.log({response})
        this.$store.state["current_field_style"] = {};
        this.$store.state["current_field_style2"] = {};
        if(err){
        this.$notify({
            title: "データの承認に失敗しました。",
            text:err,
            type: "error",
            duration: 10000
          });
        }else{
          this.gridOptions.api.purgeInfiniteCache();
          bus.$emit("stage2ConfirmatioModal",{
            title: "承認が完了しました。", 
            message: "",
            yes_label: "",
            no_label: "戻る",
            yes_color:"info",
            no_color:"default",
            model_height:"50"
          })
        }
      });

    },
    bulkApprovalStage3(){
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("bulkApprovalStage3");
    },
    bulkApprovalStage4(mode){
      /**
       * 2 - When aprove, execute at the server
       * 3 - Then show the results message.
       */
      // if(mode != "yes"){
      //   return;
      // }
      this.$ajax.post("/id_approval_history/approve_clear", {}, (err, response) => {
        console.log({response})
        if(err){
        this.$notify({
            title: "データの承認に失敗しました。",
            text:err,
            type: "error",
            duration: 10000
          });
        }else{
          this.gridOptions.api.purgeInfiniteCache();
            bus.$emit("stage2ConfirmatioModal",{
            title: "クリア", 
            message: "確認をクリアしました。",
            yes_label: "",
            no_label: "戻る",
            yes_color:"info",
            no_color:"default",
            model_height:"50"
          })
        }
      });

    },
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      var destination = "/master_user/approval/" + data.seq_id + "/" + data.fk_id;
      
      console.log('onDetailsClick', {destination});

      return this.$router.push(destination);
    },
    createColumnDefs() {
      var arr = [
        {
          headerName: 'Seq',
          field: 'seq_id',
          hide: true,
          // sort: 'desc'
        },
         {
            headerName: "SearchControl",// Used to filter manually
            field: "search_control",
            hide: true
        },
        {
          headerName: "SearchFlowControl", // Used to filter manually
          field: "search_flow_control",
          hide: true,
        },
      ];
      var i = 0;
      this.tabFieldList.forEach((f) => {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };

        if(f.type == "date_picker" ){
          fi.cellRenderer = (params) =>{
              return utils.format_date(params.value);
          }
        }else if(f.type == "datetime_picker" || f.type == "current_time"){
          fi.cellRenderer = (params) =>{
              return utils.format_date_time(params.value);
          }
        }else if(f.cellRenderer){
          fi.cellRenderer = f.cellRenderer;
        }

        arr.push(fi);
      });


      [fields.more_details, fields.record_checked].forEach(f => {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          // sort : f.id == "record_checked" ? 'desc':null,
          cellRenderer: params => {
            if (params.column.colId == "more_details") {
              if((this.isLoggedUserAdmin == true && params.data  && params.data.status_final == "未承認") || (params.data  && (params.data.next_approver == this.userId || params.data.applicant == this.userId ))){
                return this.createGridTextButton(
                "詳細",
                "color: #5b9bd5;",
                this.onDetailsClick,
                params.data
              );
              }else{
                return "-"
              }
            }
            if (params.column.colId == "record_checked") {
              if(params.data && params.data.record_checked == 1){
                params.node.data.is_selected = true;
                params.data.is_selected = true;
              }
              return this.createGridButton(
                (params.data && params.data.record_checked == 1)?"glyphicon glyphicon glyphicon-check":"glyphicon glyphicon glyphicon-unchecked",
                "color: #5b9bd5;",
                ()=>{},
                params.data
              );
            }
          }
        };
        arr.push(fi);
      });


      return arr;
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    this.userId = Vue.localStorage.get("userID") || "";
    this.isLoggedUserAdmin = this.isAdmin ;
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    var use_data_source = true;

    //AG Grid options
    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: (data) => {
        return data.seq_id;
      },
      enableSorting: true,
      enableColResize: true,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate :"<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onColumnResized: (ev, b) => {
      },
      onRowSelected: ev => {
      },
      onModelUpdated: (ev, d) => {
      },
      onGridReady:() => {

      },
      getRowStyle: params => { 
        if((this.isLoggedUserAdmin == true && params.node.data  && params.node.data.status_final == "未承認") || (params.node.data  && params.node.data.next_approver == this.userId)){
          if (params.node.data && (params.node.data.is_selected == true || this.isAllSelected == true)) {
            return { background: "orange" };
          }
        }
      },
    };
    this.initDatasource({loaded_cb:(err,data)=>{
      var active_approve_button = _.find(data,(d)=>{
        return ((this.isLoggedUserAdmin == true && d  && d.status_final == "未承認") || (d  && d.next_approver == this.userId)) && (d && (d.is_selected == true || this.isAllSelected == true))
      })
      this.disablePageApprove = typeof active_approve_button == "undefined";
    }});
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0050_id_approval_history.vue?a6a85c4e